const documentos = [
  { label: 'C.I', value: 1 },
  { label: 'Pasaporte', value: 2 },
  { label: 'DNI', value: 3 },
  { label: 'Otros', value: 4 },
];

export default documentos;
